export default defineNuxtRouteMiddleware((to, from) => {
  const cookie = useCookie('user')
  const app = useAppStore()
  const pointPopup = usePoint()

  if (cookie.value && !app.user) {
    app.user = cookie.value
  }

  if (!cookie || !cookie.value) {
    if (
      to.path === '/login' ||
      to.path === '/login/' ||
      to.path === '/' ||
      to.path === ''
    ) {
      return
    }
    return navigateTo('/')
  }
  // 로그인된 상태에서 로그인/메인 페이지 접근 시 quick 페이지로 리다이렉션
  if (
    cookie.value &&
    (to.path === '/login' ||
      to.path === '/login/' ||
      to.path === '/' ||
      to.path === '')
  ) {
    return navigateTo('/quick')
  }
})
